var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DetailBusiness = function (storeContainer) {
    var _a = storeContainer.store, requestStore = _a.requestStore, messageStore = _a.messageStore, commonStore = _a.commonStore;
    var propConnect = {
        woDetail: requestStore.woDetail,
        availableDate: requestStore.availableDate,
        messagesDetail: messageStore.messagesDetail,
        currentWOId: requestStore.currentWOId,
        currentWOType: requestStore.currentWOType,
        woStatusData: messageStore.woStatusData,
    };
    var dispatchConnect = {
        getWoDetail: function () { return requestStore.getWoDetail(); },
        getAvailableDate: function () { return requestStore.getAvailableDate(); },
        updateEntryInfo: function (entryInfo, version) { return requestStore.updateEntryInfo(entryInfo, version); },
        getMessageDetail: function () { return messageStore.getMessageDetail(requestStore.currentWOId, requestStore.currentWOType); },
        markAsRead: function () { return messageStore.markAsRead(requestStore.currentWOId, requestStore.currentWOType); },
        sendMessage: function (sendMessage) { return messageStore.sendMessage(requestStore.currentWOId, sendMessage); },
        updateCurrentWO: function (id, isReactive) { return requestStore.updateCurrentWO(id, isReactive); },
        detailClear: function () { requestStore.clear(); messageStore.clearMessageDetail(); },
        matchIntent: function (intent) { return commonStore.matchIntent(intent); },
        getCopilotConversationStatus: function (conversationId) { return commonStore.getCopilotConversationStatus(conversationId); },
        getWoStatusTimeLines: function (woId) { return messageStore.getWoStatusTimeLines(woId); },
        replyMessage: function (replyMessage) {
            return messageStore.replyMessage(requestStore.currentWOId, __assign(__assign({}, replyMessage), { woId: requestStore.currentWOId }));
        },
        getIsEnableCommunicationWithPM: function () { return messageStore.getIsEnableCommunicationWithPM(); },
    };
    return __assign(__assign({}, propConnect), dispatchConnect);
};
